import SubmissionError from '../../../../../../error/SubmissionError'
import fetch from '../../../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const create = ({ commit }, values) => {
  commit(types.EXCMRELATION_CREATE_SET_ERROR, '')
  commit(types.EXCMRELATION_CREATE_TOGGLE_LOADING)

  Object.keys(values).forEach(key => {
    if (values[key] === '') delete values[key]
  })

  return fetch('e_x_c_m_relations', { method: 'POST', body: JSON.stringify(values) })
    .then((response) => {
      commit(types.EXCMRELATION_CREATE_TOGGLE_LOADING)
      Vue.prototype.$Swal({ // show notification with success
        type: 'success',
        title: Vue.prototype.$lang.t('notifications.store.savedTitle'),
        showConfirmButton: false,
        timer: 2500
      })
      return response.json()
    })
    .then((data) => {
      commit(types.EXCMRELATION_CREATE_SET_CREATED, data)
    })
    .catch((e) => {
      commit(types.EXCMRELATION_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.EXCMRELATION_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        // commit(types.EXCMRELATION_CREATE_SET_ERROR, e.errors._error)
        let errors = ''
        for (let key in e.errors) {
          if (key !== '_error') {
            errors += Vue.prototype.$lang.t('views.excmnote.form.' + key) + ' -  ' + e.errors[key] + '<br />'
          }
        }
        Vue.prototype.$Swal({
          type: 'error',
          title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
          html: errors,
          showConfirmButton: true
        })
        return
      }
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.EXCMRELATION_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.EXCMRELATION_CREATE_RESET)
}
